import { SuccessNoteIcon } from '../../../../components/icons';
import { SuitUIButton } from '../../../../components/SuitUIButton';

const Success = ({ onContinue }: { onContinue: () => void }) => {
    return (
        <div className='h-[481px] flex flex-col justify-center items-center pt-[60px] px-4'>
            <SuccessNoteIcon />
            <p className='text-ebony text-[20px] leading-[30px] mt-[40px] mb-4  max-w-[238px] text-center'>
                Account linking request submitted
            </p>
            <p className='text-gray200 text-[14px] leading-[20px] mb-[24px] max-w-[296px] text-center'>
                You’ll receive an email notification within 24 to 48 hours once
                your request has been reviewed.
            </p>
            <SuitUIButton
                text='Continue'
                onClick={onContinue}
                fullWidth
                style='max-w-[386px]'
            />
        </div>
    );
};

export default Success;
